import {Provider} from '@angular/core';

import {GetUsuryRateUseCase} from '@features/setting/application/use_cases/get-usury-rate/get-usury-rate.use-case';

import {
  GetUsuryRateHttpProvider
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.provider';

export const GetUsuryRateUseCaseProvider: Provider[] = [
  ...GetUsuryRateHttpProvider,
  GetUsuryRateUseCase
];
